/**
 * Parse the body an apply special styles
 */
export default () => {
    const tdElements = document.getElementsByTagName('td');
    for (let i = 0, len = tdElements.length; i < len; i++) {
        const ele = tdElements.item(i);
        switch (ele?.innerText) {
            case 'CBR':
                ele.style.color = 'blue';
                break;
            case 'GPS':
                ele.style.color = 'green';
                break;
            default:
                break;
        }
    }
};
